import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { SportType } from '@frontend/sports/betting-offer/feature/model';
import { GridConfig as MsGrid } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { TrackingSource } from '@frontend/sports/tracking/feature';

import { BaseballScoreboardComponent } from './baseball-scoreboard.component';
import { CricketScoreboardComponent } from './cricket-scoreboard.component';
import { DartsScoreboardComponent } from './darts-scoreboard.component';
import { LeaderboardGameScoreboardComponent } from './leaderboard-game-scoreboard.component';
import { PairGameScoreboardComponent } from './pair-game-scoreboard.component';
import { PenaltyShootoutComponent } from './penalty-shootout.component';
import { PeriodGameScoreboardComponent } from './period-game-scoreboard.component';
import { GridScoreboardBaseComponent } from './scoreboard-base/grid-scoreboard-base.component';
import { SetGameScoreboardComponent } from './set-game-scoreboard.component';
import { SnookerScoreboardComponent } from './snooker-scoreboard.component';

@Component({
    selector: 'ms-grid-scoreboard',
    templateUrl: './grid-scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        PenaltyShootoutComponent,
        BaseballScoreboardComponent,
        CricketScoreboardComponent,
        SetGameScoreboardComponent,
        DartsScoreboardComponent,
        PairGameScoreboardComponent,
        PeriodGameScoreboardComponent,
        SnookerScoreboardComponent,
        LeaderboardGameScoreboardComponent,
    ],
})
export class GridScoreboardComponent extends GridScoreboardBaseComponent implements OnInit {
    showRedcards = false;
    @Input() hideScoreBoardColumnFooter = false;
    @Input() tracking: TrackingSource;
    @HostBinding('class') className = 'grid-scoreboard';
    constructor(private msGrid: MsGrid) {
        super();
    }

    ngOnInit(): void {
        this.showRedcards = this.event.sport.id === SportConstant.Soccer && this.msGrid.showRedCardsInSoccer;
    }

    get isLeaderboard(): boolean {
        return this.event.scoreboard.sportType === SportType.LeaderboardGame;
    }
}
